__turbopack_context__.v({
  "chevron": "Reviews-module-scss-module__bmUmPG__chevron",
  "details": "Reviews-module-scss-module__bmUmPG__details",
  "empty-star": "Reviews-module-scss-module__bmUmPG__empty-star",
  "hidden-mobile": "Reviews-module-scss-module__bmUmPG__hidden-mobile",
  "left-container": "Reviews-module-scss-module__bmUmPG__left-container",
  "logo": "Reviews-module-scss-module__bmUmPG__logo",
  "logo-container": "Reviews-module-scss-module__bmUmPG__logo-container",
  "logo-text": "Reviews-module-scss-module__bmUmPG__logo-text",
  "logo-title": "Reviews-module-scss-module__bmUmPG__logo-title",
  "mobile-controls": "Reviews-module-scss-module__bmUmPG__mobile-controls",
  "name": "Reviews-module-scss-module__bmUmPG__name",
  "quotation-icon": "Reviews-module-scss-module__bmUmPG__quotation-icon",
  "rating": "Reviews-module-scss-module__bmUmPG__rating",
  "rating-container": "Reviews-module-scss-module__bmUmPG__rating-container",
  "review": "Reviews-module-scss-module__bmUmPG__review",
  "review-item": "Reviews-module-scss-module__bmUmPG__review-item",
  "reviews": "Reviews-module-scss-module__bmUmPG__reviews",
  "reviews-container": "Reviews-module-scss-module__bmUmPG__reviews-container",
  "right-container": "Reviews-module-scss-module__bmUmPG__right-container",
  "scroll-left": "Reviews-module-scss-module__bmUmPG__scroll-left",
  "scroll-right": "Reviews-module-scss-module__bmUmPG__scroll-right",
  "scrollLeft": "Reviews-module-scss-module__bmUmPG__scrollLeft",
  "scrollRight": "Reviews-module-scss-module__bmUmPG__scrollRight",
  "show-mobile": "Reviews-module-scss-module__bmUmPG__show-mobile",
  "source": "Reviews-module-scss-module__bmUmPG__source",
  "star": "Reviews-module-scss-module__bmUmPG__star",
  "stars": "Reviews-module-scss-module__bmUmPG__stars",
  "text": "Reviews-module-scss-module__bmUmPG__text",
  "title": "Reviews-module-scss-module__bmUmPG__title",
});
